import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "nav-container__icon" }
const _hoisted_2 = { class: "nav-container__body" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "nav-container__description"
}
const _hoisted_5 = {
  key: 1,
  class: "nav-container nav-container--disabled",
  "aria-disabled": "true"
}
const _hoisted_6 = { class: "nav-container__icon" }
const _hoisted_7 = { class: "nav-container__body" }
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = {
  key: 0,
  class: "nav-container__description"
}

import { computed } from 'vue';
import { RouterLink } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'NavButton',
  props: {
  link: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  icon: {
    type: String,
    default: '•',
  },
  color: {
    type: String,
    default: '#FFF',
  },
},
  setup(__props) {

const props = __props;

const isActive = computed(() => Boolean(props.link));

return (_ctx: any,_cache: any) => {
  return (isActive.value)
    ? (_openBlock(), _createBlock(_unref(RouterLink), {
        key: 0,
        class: "nav-link",
        to: props.link
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            class: "nav-container",
            style: _normalizeStyle({ background: props.color || '#FFF' })
          }, [
            _createElementVNode("span", _hoisted_1, _toDisplayString(props.icon), 1),
            _createElementVNode("span", _hoisted_2, [
              _createElementVNode("strong", {
                class: "nav-container__text",
                innerHTML: __props.title
              }, null, 8, _hoisted_3),
              (props.description)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(props.description), 1))
                : _createCommentVNode("", true)
            ])
          ], 4)
        ]),
        _: 1
      }, 8, ["to"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(props.icon), 1),
        _createElementVNode("span", _hoisted_7, [
          _createElementVNode("strong", {
            class: "nav-container__text",
            innerHTML: __props.title
          }, null, 8, _hoisted_8),
          (props.description)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(props.description), 1))
            : _createCommentVNode("", true)
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("span", { class: "nav-container__badge" }, "준비중", -1))
      ]))
}
}

})